<template>
    <div>
        <div class="row">
            <div class="col  d-flex align-items-center"><a target="_blank" :href="'//'+domain">{{ domain }}</a></div>
            <div class="col text-right"><button class="btn btn-sm btn-light" v-if="domain != ''"
                                              @click="showModal">Edit</button></div>
        </div>
        <button class="btn btn-outline-success" v-if="domain == ''" id="show-btn" @click="showModal">Setup Domain
        </button>


        <b-modal size="lg" ref="modalDomain" hide-footer title="Setup Domain">
            <p><strong>Step 1: Change DNS to Cloudflare</strong></p>
            <ul>
                <li><a target="_blank"
                       href="https://support.cloudflare.com/hc/en-us/articles/201720164-Creating-a-Cloudflare-account-and-adding-a-website">Create
                    a Cloudflare account and add a website</a></li>
            </ul>

            <p><strong>Step 2: Add Record</strong></p>
            <ul>
                <li>Delete all records Type A</li>
                <li>Add TXT Record <br>
                    <code>
                        Type: TXT <br>

                        Name: @ <br>

                        Value: <strong>{{txt}}</strong>

                    </code>
                </li>

                <li>Add CNAME record <br>
                    <code>
                        Type: CNAME <br>

                        Name: @ <br>

                        Value: <strong>dns.gearfury.com</strong>

                    </code>
                    <img class="mt-2 mb-2 img-fluid" src="../assets/images/cname.png" alt="">
                </li>

            </ul>

            <div v-show="message !=''" class="alert alert-danger">{{message}}</div>

            <div class="form-group">
                <label for="domain"><strong>Domain</strong></label>
                <input id="domain" class="form-control" v-model="newDomain">
            </div>
            <button class="btn btn-success btn-block" @click="changeDomain">Update</button>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "ChangeDomain",
        props: ['domain', 'txt'],
        data: function () {
            return {
                message: '',
                newDomain: ''
            }
        },


        methods: {
            showModal() {
                this.newDomain = this.domain
                this.$refs['modalDomain'].show()
            },
            updateDone: function () {
                this.$emit('update', this.newDomain);
            },
            checkIsValidDomain: function (domain) {
                let re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
                return domain.match(re);
            },
            changeDomain: function () {
                let vm = this
                if (this.newDomain == '') {
                    this.message = 'Please enter Domain'
                    return false
                }

                if (this.checkIsValidDomain(this.newDomain) == null) {
                    this.message = 'Invalid Domain'
                    return false
                }

                this.$http.post(this.$config.api + 'store/domain', {domain: this.newDomain}).then(function (res) {
                    if (res.data.status == false) {
                        vm.message = res.data.message
                    } else {
                        vm.message = ''
                        vm.$refs['modalDomain'].hide()
                        vm.updateDone()
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>